import { render, staticRenderFns } from "./DocumentsProgram.vue?vue&type=template&id=593304b8&scoped=true&"
import script from "./DocumentsProgram.vue?vue&type=script&lang=ts&"
export * from "./DocumentsProgram.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsProgram.vue?vue&type=style&index=0&id=593304b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593304b8",
  null
  
)

export default component.exports